import { getEnv, getRoot, IStateTreeNode } from "mobx-state-tree";
import { WsGlobalEventsListener } from "@fidget/common/services/eventsListener";
import { ArtichokeService } from "../../services/artichokeService";
import { IChatNotifcationStore } from "../mst/ui/ChatNotificationStore";
import { SharedRootStore, SharedRootStoreEnv } from "./sharedEnv";
import { ISharedOrgConfig } from "./sharedOrgConfig";
import { SharedSpinnerService } from "./spinner/sharedSpinnerService";
import { AbstractCallService } from "@fidget/common/services/AbstractCallService";

export const sharedServicesGetters = (self: IStateTreeNode) => {
  return {
    get sharedSpinnerService(): SharedSpinnerService {
      return (getEnv(self) as SharedRootStoreEnv).spinnerService;
    },
    get sharedArtichokeService(): ArtichokeService {
      return (getEnv(self) as SharedRootStoreEnv).artichokeService;
    },
    get sharedEventListener(): WsGlobalEventsListener {
      return (getEnv(self) as SharedRootStoreEnv).eventListener;
    },
    get sharedCallService(): AbstractCallService {
      return (getEnv(self) as SharedRootStoreEnv).callService;
    }
  };
};

export const sharedChatNotificationGetter = (self: IStateTreeNode) => {
  return {
    get sharedChatNotificationStore(): IChatNotifcationStore {
      return (getRoot(self) as SharedRootStore).uiStore;
    }
  };
};

export const sharedModelsGetter = (self: IStateTreeNode) => {
  return {
    get sharedOrgConfig(): ISharedOrgConfig | undefined {
      return (getEnv(self) as SharedRootStoreEnv).modelsGetter.sharedOrgConfigGetter();
    }
  };
};

export interface SharedModelsGetter {
  sharedOrgConfigGetter: () => ISharedOrgConfig | undefined;
}
